module.exports = __webpack_public_path__ + "static/media/error.2c36f595.svg";